export enum TagStyleEnum {
  FILL = 'fill',
  OUTLINE = 'outline',
}

import { CommonModule } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core'
import { TypographyComponent } from '../typography/typography.component'
import { IconComponent } from '../icon/icon.component'
import { IconValuesType } from '../icon/icon.component.types'

@Component({
  selector: 'hyperkit-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  standalone: true,
  imports: [CommonModule, TypographyComponent, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagComponent {
  @Input() public mode: `${TagStyleEnum}` = 'fill'
  @Input() public icon!: IconValuesType | null
  @Input() public closable!: boolean
  @Input() public text!: string
  @Input() public operation!: string
  @Input() public textLeft!: string
  @Input() public textRight!: string
  @Input() public disabled!: boolean
  @Input() public selected!: boolean
  @Output() public tagComponentChange = new EventEmitter<MouseEvent>()

  public emitOnClose(event: MouseEvent): void {
    if (!this.disabled) {
      this.tagComponentChange.emit(event)
    }
  }
}
